import React from 'react'
import {
  FormControl,
  FormControlLabel,
  FormGroup,
  Checkbox,
} from '@material-ui/core'
import { FieldProps } from 'formik'
import { useErrorStyle } from 'componentsHsc'

const defaultOptionList = [
  { value: 'processing', label: '処理中' },
  { value: 'success', label: '成功' },
  { value: 'fail', label: '失敗' },
]

interface Props extends FieldProps {
  optionList: typeof defaultOptionList
  rootClassName?: string
  groupClassName?: string
  row?: boolean
  disabled?: boolean
}

const GroupOptions = ({
  field,
  form,
  optionList = defaultOptionList,
  rootClassName,
  groupClassName,
  row,
  disabled,
}: Props) => {
  const classes = useErrorStyle()
  const { errors, touched } = form
  const { name, value } = field

  const handleChange = (option: string) => (e: any) => {
    form.setFieldValue(name, {
      ...value,
      [option]: e.target.checked ? '1' : '0',
    })
  }

  return (
    <FormControl
      className={rootClassName}
      error={Boolean(errors[name] && touched[name])}>
      <FormGroup className={groupClassName} row={row}>
        {optionList.map(i => (
          <FormControlLabel
            key={i.value}
            control={
              <Checkbox
                disabled={disabled}
                color='primary'
                checked={value && Boolean(parseInt(value[i.value]))}
                onChange={handleChange(i.value)}
              />
            }
            label={i.label}
          />
        ))}
      </FormGroup>
      {errors[name] && touched[name] ? (
        <p className={classes.helperText}>{errors[name]}</p>
      ) : null}
    </FormControl>
  )
}

export default GroupOptions
